import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/intermediario";

export default class IntermediarioApi {
  /**
   * Instância da dependência da API (ofetch).
   */
  private api;

  /**
   * Cria uma nova instância da classe IntermediarioApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Verifica se o intermediario existe pelo CNPJ.
   * @param cnpj - CNPJ do intermediario
   * @returns (Promise) Boolean indicando se o intermediario existe
   */
  checkIfProviderExists(cnpj: string) {
    return this.api<boolean>(`${controller}/exists/${cnpj}`, {
      method: "GET",
    });
  }

  /**
   * Cadastra um novo intermediario
   * @param provider
   * @returns
   */
  createProvider(provider: any) {
    return this.api<any>(`${controller}/cadastrar`, {
      method: "POST",
      body: provider,
    });
  }

  /**
   * Retorna os dados de um intermediario.
   * @param codIntermediario - Código do intermediario
   * @returns Dados do intermediario
   */
  getIntermediarioData(codIntermediario: number) {
    return this.api<any>(
      `${controller}/dados-intermediario/${codIntermediario}`,
      {
        method: "GET",
      },
    );
  }

  /**
   * @returns Lista de intermediarios
   */
  list() {
    return this.api<any>(`${controller}/listar`, {
      method: "GET",
    });
  }

  /**
   * Atualiza os dados de um intermediario
   * @param provider - Dados atualizados do intermediario
   * @returns Resultado da atualização
   */
  updateProvider(provider: any) {
    return this.api<any>(`${controller}/atualizar`, {
      method: "PUT",
      body: provider,
    });
  }
}
